import { Audit, Auditable, Dto, IDName } from '@damofire/data-commons';
import { Timestamp } from 'firebase/firestore';
import { InactivityWarnings } from './inactive-params.dto';

interface DtoWithAuthDates extends Dto<string> {
  audit?: Audit & { authModifiedDate?: Timestamp | Date; disabledDate?: Timestamp | Date };
}

export interface UserCreation extends User {
  defaultRole?: string;
  orgAdmin?: boolean;
}

export type ForcedActions = 'logout' | 'refresh' | 'update';

export interface User extends DtoWithAuthDates {
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
  organization?: IDName;
  primaryDivision?: IDName;
  tokenRefresh?: boolean;
  phone?: string[];
  cookiesAccepted?: boolean;
  language?: 'en' | 'fr';
  mfaEnabled?: boolean;
  isRep?: boolean;
  inactivityStatus?: InactivityWarnings;
  forceAction?: ForcedActions;
}

export interface OrganizationLink extends Dto<string>, Auditable {
  name?: string;
  admin?: boolean;
  divisions?: { [_id: string]: DivisionRole };
  user?: User;
}

export interface DivisionRole {
  orgId?: string;
  orgName?: string;
  _id?: string;
  name?: string;
  role?: string;
  enabled?: boolean;
}

export enum ROLES {
  MANAGER = 'MANAGER',
  COLLABORATOR = 'COLLABORATOR',
  OBSERVER = 'OBSERVER',
  CONTACT = 'CONTACT',
  REPRESENTATIVE = 'REPRESENTATIVE',
}
